import { AxiosError } from "axios";
import { User, UserInfo } from "src/atoms/index.type";
import {
  ProductKeyList,
  WRAPSODY_CLOUD_URL,
  WRAPSODY_ECO_CLOUD_URL,
} from "src/config/config";

export const errorMsgNameMap: Record<string, string> = {
  INVALID_TOKEN: "Not match key",
  DUPLICATE_DATA: "This id is already joined.",
  // INVALID_SESSION: "Invalid session.",
  INVALID_SESSION: "common.alert.sessionExpired",
  NOT_FOUND_DB_SETTING: "NOT_FOUND_DB_SETTING",
  DB_CONNECTION_FAIL: "DB_CONNECTION_FAIL",
  NOT_FOUND_JDBC: "NOT_FOUND_JDBC",
  INVALID_QUERY_PATH: "INVALID_QUERY_PATH",
  FAILED_TO_DB_EXCUTE: "FAILED_TO_DB_EXCUTE",
  FAILED_TO_DB_ROLLBACK: "FAILED_TO_DB_ROLLBACK",
  INTERNAL_SERVER_ERROR: "INTERNAL_SERVER_ERROR",
  BAD_REQUEST: "BAD_REQUEST",
  INVALID_DATA: "INVALID_DATA",
  NOT_FOUND_DATA: "NOT_FOUND_DATA",
  NOT_FOUND_DATA_FOR_UPDATE: "NOT_FOUND_DATA_FOR_UPDATE",
  NOT_FOUND_DATA_FOR_DELETE: "NOT_FOUND_DATA_FOR_DELETE",
  INVALID_USER_ID_PWD: "INVALID_USER_ID_PWD",
  ALREADY_LOGIN: "ALREADY_LOGIN",
  NO_DATA: "NO_DATA",
  NOT_FOUND_CODE: "siteType.premium.detail.plan.invalidPromotionCode", // 코드가 유효하지 않습니다.
  OVER_VALIDITY_TIME:
    "유효기간이 만료된 코드입니다.\n프로모션 코드를 다시 신청해주세요.",
  ALEADY_REQUESTED: "siteType.premium.detail.plan.alert.Msg1",
  NOT_VALID_COUPON_CODE: "siteType.premium.detail.plan.invalidPromotionCode",
  INVALID_COUPON_CODE: "siteType.premium.detail.plan.invalidPromotionCode",
  INVALID_COUPON_USER: "siteType.premium.detail.plan.invalidPromotionCode",
  ALREADY_EXIST_USER: "siteManagement.createSiteModal.alert.aleadyExistUser",
};

export const handleErrorMsgMapper = ({
  e,
  reqType = "default",
}: {
  e: AxiosError | any; // 에러
  reqType?: string; // 요청 타입
}) => {
  const result = JSON.parse(window.sessionStorage.getItem("recoil") ?? "");
  const userInfo: User = result?.userInfo;

  if (
    window.location.pathname.includes("my-account") &&
    e.response?.data?.errorCode === "NO_DATA"
  ) {
    return "navBar.myAccount.popUp.changePassword.checkMsg5";
  }
  if (
    e.response?.data?.errorCode === "INVALID_SESSION" &&
    ProductKeyList.includes(userInfo?.loginType)
  ) {
    // console.log("INVALID_SESSION!!!!", userInfo);
    if (userInfo?.loginType === "WRAPSODY") {
      window.parent.location.href = WRAPSODY_CLOUD_URL;
    } else if (userInfo?.loginType === "WRAPSODY_ECO") {
      window.parent.location.href = WRAPSODY_ECO_CLOUD_URL;
    }
    // return "쿠키를 허용해주세요.";
  }

  // flow 
  // 1. errorMessage가 있으면 먼저 표기
  // 2. errorCode에 매핑되는 설명 표기
  // 3. 매핑값 없으면 errorCode 표기
  if (e.response?.data?.errorMessage) {
    if (e.response?.data?.errorMessage === "ALREADY_EXIST_USER") {
      return "siteManagement.createSiteModal.aleadyExistUser";
    } else return e.response?.data?.errorMessage;
  }
  if (e.response?.data?.errorCode) {
    return (
      errorMsgNameMap[e.response?.data?.errorCode] ??
      e.response?.data?.errorCode
    );
  }

  if (e.response?.status === 404) return "잘못된 요청";
  if (e.response?.status === 503) return "서버가 준비되지 않았습니다.";
  if (e.response?.status === 500) return "서버에러 발생";
  if (e.response?.status === 502) return "서버에러 발생";

  return "알 수 없는 에러 발생";
};
